import { isValidISODate } from "@etframework/ui.components";
import { useMemo } from "react";
import { useViewUnmanaged } from "../data/queries/viewQueries";
import Enums from "../types/enums";
import { useSystemViews } from "./useSystemViews";

export const useGridView = (viewId, viewType = 0) => {
  const { data: currentView, isPending: isPendingView } =
    useViewUnmanaged(viewId);

  const { getSystemView } = useSystemViews();

  const filters = useMemo(() => {
    if (viewType !== Enums.ViewType.Custom) {
      return getSystemView(viewType)?.Filters;
    }
    return currentView?.Filters;
  }, [currentView, viewType, viewId]);

  const columnFilterOptions = {
    StageType: {
      matchCase: true,
      predicate: "and"
    }
  };

  const formattedFilters = filters?.flatMap((filter) => {
    const values = filter.Value.split("^").map((value) =>
      value === "" ? null : value.trim()
    );
    const operators = filter.Operator.split("^");
    const columnOptions = columnFilterOptions[filter.ColumnName];

    const isDateRange =
      values.length === 2 &&
      values.every((value) => isValidISODate(value) || value instanceof Date);

    let predicate = "or";

    if (operators[0] == "notequal" || isDateRange) predicate = "and";

    return values.map((value, index) => ({
      field: filter.ColumnName,
      matchCase: columnOptions?.matchCase || false,
      operator: operators[index],
      predicate: predicate,
      value: columnOptions?.valueModifier
        ? columnOptions?.valueModifier(value)
        : value
    }));
  });

  const hiddenColumns = useMemo(
    () => currentView?.HiddenColumns,
    [currentView]
  );
  const columnOrder = useMemo(() => currentView?.ColumnOrder, [currentView]);
  const sorts = useMemo(() => currentView?.Sorts, [currentView]);

  return {
    formattedFilters,
    isPendingView,
    currentView,
    hiddenColumns,
    columnOrder,
    sorts
  };
};
